'use es6';

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for providing source app information
 *
 * @param {object} value                    the context value
 * @param {String} value.sourceApp          the source application rendering the sidebar (for example, 'CRM_UI')
 */

export const SourceAppContext = /*#__PURE__*/createContext(null);
SourceAppContext.Provider.propTypes = {
  value: PropTypes.shape({
    sourceApp: PropTypes.string
  }).isRequired
};